import { styled } from '@mui/joy';

import { externalQuoteTheme } from 'external-quote/styles';

export const SearchContainer = styled('div')({
  backgroundColor: '#F5F5F5',
  borderBottom: '1px solid #E0E0E0',
  padding: '8px 16px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '12px',
  minHeight: '50px',
});

export const LeftSection = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  flex: 1,
});

export const QuantityInput = styled('input')({
  width: '50px',
  padding: '4px 8px',
  border: '1px solid #D0D0D0',
  borderRadius: '3px',
  fontSize: '14px',
  textAlign: 'center',
  height: '28px',
});

export const SearchInput = styled('input')({
  width: '280px',
  padding: '4px 8px',
  border: '1px solid #D0D0D0',
  borderRadius: '3px',
  fontSize: '14px',
  height: '28px',

  '&::placeholder': {
    color: '#999',
  },

  '&:focus': {
    outline: 'none',
    borderColor: externalQuoteTheme.colors.primaryBlue,
  },
});

export const ActionButton = styled('button')({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  padding: '6px 12px',
  border: '1px solid #D0D0D0',
  backgroundColor: '#FFFFFF',
  borderRadius: '3px',
  fontSize: '14px',
  color: '#333333',
  cursor: 'pointer',
  transition: 'background-color 0.2s',
  height: '28px',
  whiteSpace: 'nowrap',

  '&:hover': {
    backgroundColor: '#F5F5F5',
  },
});

export const BOMConfiguratorButton = styled('button')({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  padding: '6px 12px',
  border: 'none',
  backgroundColor: externalQuoteTheme.colors.primaryBlue,
  borderRadius: '3px',
  fontSize: '14px',
  color: '#FFFFFF',
  cursor: 'pointer',
  transition: 'background-color 0.2s',
  height: '28px',
  whiteSpace: 'nowrap',

  '&:hover': {
    backgroundColor: '#0052A3',
  },
});

export const RightSection = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
});

export const PriceInfo = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  fontSize: '15px',
});

export const PriceLabel = styled('span')({
  color: '#666666',
  fontSize: '15px',
});

export const PriceValue = styled('span')({
  fontWeight: 600,
  color: '#333333',
  fontSize: '15px',
});

export const GPValue = styled('span')({
  color: '#FF9800',
  fontWeight: 500,
  fontSize: '15px',
});

export const FilterButton = styled('button')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '32px',
  height: '32px',
  border: `1px solid ${externalQuoteTheme.colors.borderGray}`,
  backgroundColor: '#FFFFFF',
  borderRadius: externalQuoteTheme.borderRadius.sm,
  cursor: 'pointer',
  transition: 'background-color 0.2s',

  '&:hover': {
    backgroundColor: '#F5F5F5',
  },
});
